import { RevalidateUserData, SignInType } from "../../../../global/paywall/paywallInterfaces"
import { DetailUpdateError, RevalidationStep } from "../../../../global/paywall/useDetailsUpdate"


interface PaywallRevalidateChooseModeProps {
    userData: RevalidateUserData
    error: DetailUpdateError
    revalidationType: SignInType
    setRevalidationType: (type: SignInType) => void
}



export const PaywallRevalidateChooseMode = ({ userData, error, revalidationType, setRevalidationType }: PaywallRevalidateChooseModeProps) => {
    const isEmailOnly = userData.obfuscatedEmail && !userData.obfuscatedPhoneNumber;
    const renderEmailOnly = () => {
        return (
            <div className='description email-only'>
                שמנו לב שעבר זמן מאז האימות האחרון שלך. <br />
                לשמירה על אבטחת החשבון, נבקש לבצע  <br />
                אימות מחדש באמצעות קוד חד פעמי  <br />
                שיישלח לכתובת הדוא״ל  <br />
                {userData.obfuscatedEmail}  <br />
            </div>
        );
    };

    return (
        <div className="paywall-revalidate-choose-mode">
            <h2 className='title'>אימות מנוי</h2>
            {isEmailOnly ? renderEmailOnly() :
                <>
                    <div className='description'>
                        שמנו לב שעבר זמן מאז האימות האחרון שלך. <br />
                        לשמירה על אבטחת החשבון, נבקש לבצע אימות מחדש  <br />
                        באמצעות קוד חד פעמי
                    </div>
                    <div className="radio-options">
                        <label className="radio-option">
                            <input
                                type="radio"
                                name="revalidation-method"
                                value="email"
                                checked={revalidationType === SignInType.otpEmail}
                                onChange={() => setRevalidationType(SignInType.otpEmail)}
                            />
                            <div className="radio-content">
                                <div className="radio-title">לקבלת קוד באמצעות דוא״ל</div>
                                <div className="radio-details">{userData.obfuscatedEmail}</div>
                            </div>
                        </label>

                        <label className="radio-option">
                            <input
                                type="radio"
                                name="revalidation-method"
                                value="phone"
                                checked={revalidationType === SignInType.otpPhone}
                                onChange={() => setRevalidationType(SignInType.otpPhone)}
                            />
                            <div className="radio-content">
                                <div className="radio-title">לקבלת קוד באמצעות מס׳ טלפון נייד</div>
                                <div className="radio-details">שמסתיים בספרות {`${userData.obfuscatedPhoneNumber}****-***`}</div>
                            </div>
                        </label>
                    </div>
                </>
            }
        </div>
    );
};
